/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest, put, call } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { SagaIterator } from 'redux-saga';
import {
  CATALOG_GET_LIST_REQUEST,
  CATALOG_RESET,
  GET_GROUPS_REQUEST,
  GET_MODELS_REQUEST,
  GET_MODIFICATION_REQUEST,
  GET_PARTS_REQUEST,
  GET_SUBGROUPS_REQUEST,
  MarkWithBrandProps,
  SEARCH_BY_VIN_REQUEST,
} from './types';
import {
  getCatalogAction,
  getGroupsAction,
  getModelsAction,
  getModificationAction,
  getPartsAction,
  getScheme,
  getSubGroupsAction,
  searchByVINAction,
  setAllMarksAction,
  setCatalogStepAction,
} from './actions';
import {
  GroupsModelDTO,
  ModelsMarkDTO,
  ModificationsResponseDTO,
  PartsModelDTO,
  SearchByVinDTO,
  TypeDTO,
} from '../../types';
import { ActionType } from 'deox';
import { CatalogApi } from '../../services/Catalog';
import { Steps } from '../../constants/catalogsSteps';
import { searchSuppliersAction } from '../cart/actions';
import { CartsApi } from '../../services/Cart';
import { SupplierDTO } from '../cart/types';
import { routes } from '../../constants/routes';
import { generatePath } from 'react-router-dom';

// ======== GET CATALOGS ========
function* getCatalogSaga(): SagaIterator {
  try {
    const response: AxiosResponse<TypeDTO[]> = yield call(CatalogApi.getCatalogs);
    // const response = { data: CatalogsMock };
    yield put(getCatalogAction.success(response.data));
    const allMarksWithBrandId: MarkWithBrandProps[] = response.data.reduce(
      (acc: MarkWithBrandProps[], brand: TypeDTO) => {
        const marksWithBrandId = brand.marks.map(mark => ({
          ...mark,
          brandId: brand.id,
          name: `${mark.name} (${brand.name})`,
        }));
        return acc.concat(marksWithBrandId);
      },
      [],
    );
    yield put(setAllMarksAction(allMarksWithBrandId));
  } catch (error: any) {
    yield put(getCatalogAction.failure(error));
  }
}

// ======== GET MODELS ========
function* getModelsSaga(action: ReturnType<typeof getModelsAction.request>): SagaIterator {
  const { payload } = action;
  const { type, mark } = payload;
  // const type = yield select(state => state.catalog.selectedCar.type);
  // const mark = yield select(state => state.catalog.selectedCar.mark);

  try {
    const response: AxiosResponse<ModelsMarkDTO> = yield call(() =>
      CatalogApi.getModels({ type, mark }),
    );

    // const response = { data: MockModelsByBrand };
    yield put(getModelsAction.success(response.data.models));
  } catch (error: any) {
    yield put(getModelsAction.failure(error));
  }
}

// ======== GET MODIFICATIONS ========
function* getModificationsSaga(
  action: ActionType<typeof getModificationAction.request>,
): SagaIterator {
  // const page = action.payload;
  // const type = yield select(state => state.catalog.selectedCar.type);
  // const mark = yield select(state => state.catalog.selectedCar.mark);
  // const model = yield select(state => state.catalog.selectedCar.model);

  try {
    const response: AxiosResponse<ModificationsResponseDTO> = yield call(() =>
      CatalogApi.getModification(action.payload),
    );

    yield put(getModificationAction.success(response.data));
  } catch (error: any) {
    yield put(setCatalogStepAction(Steps.GroupList));
    // if (
    //   (error.response.data.code === 400 &&
    //     error.response.data.message === 'Модификации не поддерживаются') ||
    //   error.response.data.code === 500
    // ) {
    //   yield put(setCatalogStepAction(Steps.GroupList));
    // }
    yield put(getModificationAction.failure(error));
  }
}

function* getGroupsSaga(action: ReturnType<typeof getGroupsAction.request>): Generator {
  const { type, mark, model, modification } = action.payload;
  try {
    const response: AxiosResponse<GroupsModelDTO> | any = yield call(() =>
      CatalogApi.getGroups({ type, mark, model, modification }),
    );

    yield put(getGroupsAction.success(response.data.groups));
  } catch (error: any) {
    if (error) {
      // Handle error response when it is an AxiosError
      yield put(getGroupsAction.failure(error.response?.data?.message || 'Error occurred'));
    } else {
      // For non-Axios errors, handle accordingly
      yield put(getGroupsAction.failure('Unknown error occurred'));
    }
  }
}

function* getSubGroupsSaga(action: ReturnType<typeof getSubGroupsAction.request>): Generator {
  try {
    const { type, mark, model, modification, group } = action.payload;
    const response: AxiosResponse<GroupsModelDTO> | any = yield call(() =>
      CatalogApi.getSubGroups({ type, mark, model, modification, group }),
    );
    yield put(getSubGroupsAction.success(response.data.groups));
  } catch (error: any) {
    if (error) {
      // Handle error response when it is an AxiosError
      yield put(getSubGroupsAction.failure(error.response?.data?.message || 'Error occurred'));
    } else {
      // For non-Axios errors, handle accordingly
      yield put(getSubGroupsAction.failure('Unknown error occurred'));
    }
  }
}

function* getPartsSaga(action: ReturnType<typeof getPartsAction.request>): Generator {
  try {
    // const type = yield select(state => state.catalog.selectedCar.type);
    // const mark = yield select(state => state.catalog.selectedCar.mark);
    // const model = yield select(state => state.catalog.selectedCar.model);
    // const modification = yield select(state => state.catalog.selectedCar.modification);
    // const group = yield select(state => state.catalog.selectedCar.group);
    // const parentgroup = yield select(state => state.catalog.selectedCar.parentGroup);
    const { type, mark, model, modification, group, parentId } = action.payload;

    const response: AxiosResponse<PartsModelDTO> | any = yield call(() =>
      CatalogApi.getParts({ type, mark, model, modification, group, parentId }),
    );
    yield put(getPartsAction.success(response.data));
    yield put(getScheme.request());
  } catch (error: any) {
    yield put(getPartsAction.failure(error.message));
  }
}

function* getSchemeSaga(action: ReturnType<typeof getPartsAction.request>): Generator {
  try {
    // const type = yield select(state => state.catalog.selectedCar.type);
    // const mark = yield select(state => state.catalog.selectedCar.mark);
    // const model = yield select(state => state.catalog.selectedCar.model);
    // const modification = yield select(state => state.catalog.selectedCar.modification);
    // const group = yield select(state => state.catalog.selectedCar.group);
    // const parentGroup = yield select(state => state.catalog.selectedCar.parentGroup);
    const { type, mark, model, modification, group, parentId } = action.payload;
    const response: AxiosResponse<any> | any = yield call(() =>
      CatalogApi.getScheme({ type, mark, model, modification, group, parentId }),
    );

    let blobData: Blob;
    if (response.data instanceof Blob) {
      blobData = response.data;
    } else {
      blobData = new Blob([response.data], { type: 'image/png' });
    }

    const imageUrl = URL.createObjectURL(blobData);
    yield put(getScheme.success(imageUrl));
  } catch (error: any) {
    yield put(getPartsAction.failure(error.message));
  }
}

function* searchByVINSaga(action: ReturnType<typeof searchByVINAction.request> | any): Generator {
  try {
    const response: AxiosResponse<SearchByVinDTO> | any = yield call(
      CatalogApi.searchByVIN,
      action.payload,
    );
    console.log(response.data.acat_search, ' response');
    console.log(response.data.suppliers_search, ' response');

    // const vins = response.data.vins || [];
    // const marks = response.data.marks || [];

    // console.log(action.payload, 'action.payload');

    // if (vins.length && marks.length) {
    yield put(searchByVINAction.success(response.data.acat_search));
    // } else {
    //   const param = {
    //     text: action.payload,
    //   };
    yield put(searchSuppliersAction.success(response.data.suppliers_search));
    //   yield put(searchByVINAction.success(response.data));
    // window.location.href = generatePath(routes.CATALOG_SEARCH_BAR_RESULTS, {
    //   searchText: action.payload,
    // });
    // }
  } catch (error: any) {
    yield put(searchByVINAction.failure(error.response?.data?.message || 'Ошибка поиска по VIN'));
  }
}

function* resetCatalogSaga() {
  localStorage.removeItem('carState');
  yield;
}

// function* getGroupsSaga(action: ActionType<typeof getGroupsAction.request>): SagaIterator {
//   console.log('getGroupsSaga', action);
//   const type = yield select(state => state.catalog.selectedCar.type);
//   const mark = yield select(state => state.catalog.selectedCar.mark);
//   const model = yield select(state => state.catalog.selectedCar.model);

//   try {
//     // const response: AxiosResponse<ModificationsResponseDTO> = yield call(() =>
//     //   CatalogApi.getModification(type, mark, model, page),
//     // );

//     // yield put(getGroupsAction.success(response.data));
//   } catch (error: any) {
//     yield put(getGroupsAction.failure(error));
//   }
// }

function* catalogSaga(): SagaIterator {
  yield takeLatest(CATALOG_GET_LIST_REQUEST, getCatalogSaga);
  yield takeLatest(GET_MODELS_REQUEST, getModelsSaga);
  yield takeLatest(GET_MODIFICATION_REQUEST, getModificationsSaga);
  yield takeLatest(GET_GROUPS_REQUEST, getGroupsSaga);
  yield takeLatest(GET_SUBGROUPS_REQUEST, getSubGroupsSaga);
  yield takeLatest(GET_PARTS_REQUEST, getPartsSaga);
  yield takeLatest(GET_PARTS_REQUEST, getSchemeSaga);
  yield takeLatest(SEARCH_BY_VIN_REQUEST, searchByVINSaga);
  yield takeLatest(CATALOG_RESET, resetCatalogSaga);
}

export default catalogSaga;
